import { useState } from "react";

import Chip from "@mui/material/Chip";
import TableCell from "@mui/material/TableCell";

import { request } from "@/Api";
import BidRowButtons from "@/bids/BidRowButtons";
import { InternalLink } from "@/common/CommonComponents";
import { CustomRow } from "@/table/CustomTable";
import { formattedCurrency } from "@/utils";
import { BID_ACTIVITY_SIGNED, BID_STATUS_SIGNED } from "@/sheet/constants";

const BID_STATUS_COLOR_MAP = {
    Drafts: "default",
    "Pending EP Approval": "warning",
    "Pending Finance Approval": "warning",
    "EP Approved": "info",
    "Pending Signature": "info",
    "Signed by Client": "success",
};

const getStatusColor = (status) => BID_STATUS_COLOR_MAP[status] ?? "default";

const BidRow = ({ item, items, setItems, deleteItem }) => {
    const bid = item;

    const handleBidFileUploaded = (bidId, files) => {
        request
            .post(`/bids/${bidId}/activity`, {
                action: BID_ACTIVITY_SIGNED,
                note: "Confirm client signed by uploading existing signature",
            })
            .then(() => {
                setItems(
                    items.map((b) =>
                        b.id !== bidId
                            ? b
                            : {
                                  ...b,
                                  status: BID_STATUS_SIGNED,
                                  files: files,
                              },
                    ),
                );
            });
    };

    const handleDelete = () => {
        request.delete(`/bids/${bid.id}`).then(() => {
            deleteItem(bid.id);
        });
    };

    return (
        <CustomRow>
            <TableCell
                sx={{
                    minWidth: 150,
                    maxWidth: 200,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                <InternalLink href={`/bids/${bid.id}`} color="primary">
                    {bid.name}
                </InternalLink>
            </TableCell>
            <TableCell
                align="left"
                sx={{
                    minWidth: 150,
                    maxWidth: 220,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {bid.project ? (
                    <InternalLink
                        href={`/projects/${bid.project.id}`}
                        color="primary"
                    >
                        {bid.project.name}
                    </InternalLink>
                ) : null}
            </TableCell>
            <TableCell
                align="left"
                sx={{
                    minWidth: 120,
                    maxWidth: 180,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {bid.project?.client?.name}
            </TableCell>
            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                {formattedCurrency(bid.client_quoted, bid.project?.currency)}
            </TableCell>
            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                {(bid.gross_profit_margin * 100).toFixed(2) + "%"}
            </TableCell>
            <TableCell align="left">
                <Chip
                    label={bid.status}
                    variant="outlined"
                    color={getStatusColor(bid.status)}
                />
            </TableCell>
            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                <BidRowButtons
                    bid={bid}
                    handleDelete={handleDelete}
                    handleBidFileUploaded={handleBidFileUploaded}
                />
            </TableCell>
        </CustomRow>
    );
};

export default BidRow;
